import LegacyPage from './LegacyPage.container'

export default LegacyPage
